import { post, get } from '@/utils/request';
import { EditorProjectParams, EditorProjectResponse } from '@/services/types';
import { postAndDownloadFile } from '@/utils';

class EditorService {
  /**
   * 获取编辑器工程列表
   * @param params 任务参数 { ...... }
   * @returns 返回数据
   */
  async getEditorProjectList(params: any): Promise<any> {
    // 真实接口调用（暂时注释）
    return get('/clip/project/list', params) as unknown as any;
  }

  /**
   * 获取合成价格
   * @param params 任务参数 { ...... }
   * @returns 返回数据
   */
  async getEditorPrices(params: any): Promise<any> {
    // 真实接口调用（暂时注释）
    return get('/clip/price-list', params) as unknown as any;
  }

  /**
   * 获取编辑器工程详情
   * @param params 参数 { ...... }
   * @returns 返回数据
   */
  async getEditorProjectInfo(params: any): Promise<any> {
    // 模拟返回数据
    const mockResponse: any = {
      code: 0,
      data: {},
      msg: 'success',
    };
    return mockResponse;

    // 真实接口调用（暂时注释）
    // return post('/task/submit', params) as unknown as EditorTaskSubmitResponse;
  }

  /**
   * 新建编辑器工程
   * @param params 请求参数 { ...... }
   * @returns 返回数据
   */
  async addEditorProject(params: any): Promise<any> {
    // // 模拟返回数据
    // const mockResponse: any = {
    //   code: 0,
    //   data: {},
    //   msg: 'success',
    // };
    // return mockResponse;

    // 真实接口调用（暂时注释）
    return post('/clip/project/create', params) as unknown as any;
  }

  /**
   * 删除编辑器工程
   * @param params 请求参数 { ...... }
   * @returns 返回数据
   */
  async delEditorProject(params: any): Promise<any> {
    return post('/clip/project/delete', params) as unknown as any;
  }

  /**
   * 复制编辑器工程
   * @param params 请求参数 { ...... }
   * @returns 返回数据
   */
  async copyEditorProject(params: any): Promise<any> {
    return post('/clip/project/copy', params) as unknown as any;
  }

  /**
   * 重命名编辑器工程
   * @param params 请求参数 { ...... }
   * @returns 返回数据
   */
  async renameEditorProject(params: any): Promise<any> {

    return post('/clip/project/update', params) as unknown as any;
  }

  /**
   * 下载作品
   * @param params 请求参数 { ...... }
   * @param fileName 可选的文件名，主要用于文件夹下载
   * @returns 返回数据
   */
  async downloadEditorProjectVideo(
    params: any,
    fileName?: string
  ): Promise<any> {
    await postAndDownloadFile('/asset/download', params, fileName);

    return Promise.resolve({
      code: 0,
      data: { url: '' },
      message: 'Download started.',
      success: true,
    });
  }

  /**
   * 获取用户资产列表
   * @param params 请求参数 { ...... }
   * @returns 返回数据
   */
  async getUserMaterialList(params: any): Promise<any> {
    return post('/asset/list', params) as unknown as any;
  }

  /**
   * 选中资产放入资源库
   * @param params 请求参数 { ...... }
   * @returns 返回数据
   */
  async moveUserMaterials(params: any): Promise<any> {
    // 模拟返回数据
    const mockResponse: any = {
      code: 0,
      data: {},
      msg: 'success',
    };
    return mockResponse;

    // 真实接口调用（暂时注释）
    // return post('/task/submit', params) as unknown as EditorTaskSubmitResponse;
  }

  /**
   * 提交消费米粒
   * @param params 请求参数 { ...... }
   * @returns 返回数据
   */
  async submitConsumeCredits(params: any): Promise<any> {
    // 模拟返回数据
    const mockResponse: any = {
      code: 0,
      data: {},
      msg: 'success',
    };
    return mockResponse;

    // 真实接口调用（暂时注释）
    // return post('/task/submit', params) as unknown as EditorTaskSubmitResponse;
  }

  /**
   * 提交编辑器工程
   * @param params 请求参数 { ...... }
   * @returns 返回数据
   */
  async submitEditorProject(params: any): Promise<any> {
    // 模拟返回数据
    const mockResponse: any = {
      code: 0,
      data: {},
      msg: 'success',
    };
    return mockResponse;

    // 真实接口调用（暂时注释）
    // return post('/task/submit', params) as unknown as EditorTaskSubmitResponse;
  }

  /**
   * 后台中转阿里云视频编辑接口
   * @param params 请求参数 { ...... }
   * @returns 返回数据
   */
  async openApiPost(params: any): Promise<any> {
    // 模拟返回数据
    console.log('openApiPost', params);
    const mockResponse: any = {
      code: 0,
      data: {},
      msg: 'success',
    };
    return mockResponse;

    // 真实接口调用（暂时注释）
    // return post('/task/submit', params) as unknown as EditorTaskSubmitResponse;
  }

  /**
   * 提交剪辑任务-前端导出消费米粒
   * @param params 请求参数 { project_id, ex_project_id, duration, resolution, fps, totalTime, size }
   * @returns 返回数据
   */
  async submitClipTask(params: {
    project_id?: string | null;
    ex_project_id?: string | null;
    duration: number;
    resolution: string;
    fps: number;
    totalTime?: number | null;
    size?: number | null; // 视频大小（字节）
    source?: string;    // 后端导出必填
    source_id?: string; // 后端导出必填
    name?: string; // 后端导出必填
    format?: string; // 后端导出必填
    thumb?: string; // 后端导出必填
    watermark?: boolean; // 后端导出必填
    json_url?: string; // 后端导出必填
    export_type?: number | null; // 后端导出必填
  }): Promise<any> {
    return post('/clip/task/submit', params) as unknown as any;
  }
}

export default new EditorService();
